import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'member',
    loadChildren: () =>
      import('./features/member/member.module').then((m) => m.MemberModule),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./features/member/member.module').then((m) => m.MemberModule),
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
